import api from "./axios";

// Maps the human-friendly "type" from the Holdings form to our backend
// AssetClass enum. Keep in sync with Backend_Web/api/models.py::AssetClass.
export const TYPE_TO_ASSET_CLASS = {
  "Stocks": "equity",
  "Mutual Funds": "mutual_fund",
  "ETF": "etf",
  "Real Estate / Land": "real_estate",
  "Bonds": "bond",
  "Cash / Savings": "cash",
  "Gold / Commodities": "commodity",
  "Crypto": "crypto",
  "Private Business": "private",
  "Other": "other",
};

export const ASSET_CLASS_TO_TYPE = Object.fromEntries(
  Object.entries(TYPE_TO_ASSET_CLASS).map(([k, v]) => [v, k])
);

export const listManualAssets = () => api.get("/api/assets/manual/");

export const createManualAsset = (payload) =>
  api.post("/api/assets/manual/", payload);

export const updateManualAsset = (id, payload) =>
  api.patch(`/api/assets/manual/${id}/`, payload);

export const deleteManualAsset = (id) =>
  api.delete(`/api/assets/manual/${id}/`);

// Upload a PDF and get back proposed manual-asset rows the user can review.
export const extractAssetsFromDocument = (file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/api/assets/extract-from-document/", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 90_000,
  });
};
